module.exports = __webpack_public_path__ + "img/favicon.1e2b26cd.png";